import ACRStore from "./ACRStore";

/**
 * Clear all errors for a specific submission
 * This includes field errors, full field errors, submit errors, and original error fields
 */
export var clearSubmissionErrors = function clearSubmissionErrors(submissionId) {
  ACRStore.update(function (store) {
    var _store$fieldErrors, _store$fullFieldError, _store$submitErrors, _store$originalErrorF;
    if ((_store$fieldErrors = store.fieldErrors) !== null && _store$fieldErrors !== void 0 && _store$fieldErrors[submissionId]) {
      delete store.fieldErrors[submissionId];
    }
    if ((_store$fullFieldError = store.fullFieldErrors) !== null && _store$fullFieldError !== void 0 && _store$fullFieldError[submissionId]) {
      delete store.fullFieldErrors[submissionId];
    }
    if ((_store$submitErrors = store.submitErrors) !== null && _store$submitErrors !== void 0 && _store$submitErrors[submissionId]) {
      delete store.submitErrors[submissionId];
    }
    if ((_store$originalErrorF = store.originalErrorFields) !== null && _store$originalErrorF !== void 0 && _store$originalErrorF[submissionId]) {
      delete store.originalErrorFields[submissionId];
    }
  });
};

/**
 * Clear changed fields and errors after successful save/submit
 */
export var clearChangedFieldsAndErrors = function clearChangedFieldsAndErrors(patientId, submissionId) {
  ACRStore.update(function (store) {
    var _store$submissionChan, _store$fieldErrors2, _store$fullFieldError2, _store$submitErrors2, _store$originalErrorF2;
    // Clear changed fields set (fields are now saved)
    if ((_store$submissionChan = store.submissionChangedFields) !== null && _store$submissionChan !== void 0 && (_store$submissionChan = _store$submissionChan[patientId]) !== null && _store$submissionChan !== void 0 && _store$submissionChan[submissionId]) {
      store.submissionChangedFields[patientId][submissionId] = new Set();
    }

    // Clear errors (save was successful)
    if ((_store$fieldErrors2 = store.fieldErrors) !== null && _store$fieldErrors2 !== void 0 && _store$fieldErrors2[submissionId]) {
      delete store.fieldErrors[submissionId];
    }
    if ((_store$fullFieldError2 = store.fullFieldErrors) !== null && _store$fullFieldError2 !== void 0 && _store$fullFieldError2[submissionId]) {
      delete store.fullFieldErrors[submissionId];
    }
    if ((_store$submitErrors2 = store.submitErrors) !== null && _store$submitErrors2 !== void 0 && _store$submitErrors2[submissionId]) {
      delete store.submitErrors[submissionId];
    }
    if ((_store$originalErrorF2 = store.originalErrorFields) !== null && _store$originalErrorF2 !== void 0 && _store$originalErrorF2[submissionId]) {
      delete store.originalErrorFields[submissionId];
    }
  });
};

/**
 * Clear a specific field error when user edits the field
 */
export var clearFieldError = function clearFieldError(submissionId, fieldName) {
  ACRStore.update(function (store) {
    var _store$fieldErrors3;
    if ((_store$fieldErrors3 = store.fieldErrors) !== null && _store$fieldErrors3 !== void 0 && (_store$fieldErrors3 = _store$fieldErrors3[submissionId]) !== null && _store$fieldErrors3 !== void 0 && _store$fieldErrors3[fieldName]) {
      var _Object$keys, _store$fieldErrors4;
      delete store.fieldErrors[submissionId][fieldName];

      // Clean up empty error maps
      if (((_Object$keys = Object.keys(((_store$fieldErrors4 = store.fieldErrors) === null || _store$fieldErrors4 === void 0 ? void 0 : _store$fieldErrors4[submissionId]) || {})) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) === 0) {
        delete store.fieldErrors[submissionId];
      }
    }
  });
};

/**
 * Store field-level errors in ACRStore from API response
 */
export var storeFieldErrors = function storeFieldErrors(fieldErrorMap, fullFieldErrors, submissionId) {
  if (!submissionId) return;
  ACRStore.update(function (store) {
    if (fieldErrorMap) {
      if (!store.fieldErrors) {
        store.fieldErrors = {};
      }
      store.fieldErrors[submissionId] = fieldErrorMap;

      // Track original error fields to show them in missing tab
      if (!store.originalErrorFields) {
        store.originalErrorFields = {};
      }
      store.originalErrorFields[submissionId] = new Set(Object.keys(fieldErrorMap));
    }

    // Store full field errors with conditional metadata
    if (fullFieldErrors) {
      if (!store.fullFieldErrors) {
        store.fullFieldErrors = {};
      }
      store.fullFieldErrors[submissionId] = fullFieldErrors;
    }
  });
};